var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio"},[_c('div',{staticClass:"radioBox"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"itemRadio",class:{'active' : index === _vm.type},on:{"click":function($event){return _vm.change(index)}}},[_c('i',{class:item.icon})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }